import { apiRoutes } from "../Constant/ApiRoutes";
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../apiRequest";

//Get MailBox Contact Details
export const getMailBoxDetails = () => {
  return getRequest(apiRoutes.kbSharedMainBox);
};

//Get KB Info
export const getKbInfo = () => {
  return getRequest(apiRoutes.kbSettingsData);
};

//to fetch all available features
export const getAvailableFeatures = () => {
  return getRequest(apiRoutes.availableFeatures);
};

export const getLoggedInUserDetails = () => {
  return getRequest(apiRoutes.getUserDetails);
}

//Branding
export const postSiteBranding = (payload) => {
  return postRequest(apiRoutes.kbBranding, payload);
};

export const putSiteBranding = (payload) => {
  return putRequest(apiRoutes.kbBranding, payload);
};

// SiteSettings
export const putSiteSetting = (payload) => {
  return putRequest(apiRoutes.kbSiteSetting, payload);
};

//// Domain Check
export const domainCheck = (payload) => {
  return getRequest(apiRoutes.kbcheckSubdomain, { keyword: payload });
};

//// Code Snippets
export const postSnippets = (payload) => {
  return postRequest(apiRoutes.kbSnippets, payload);
};

export const putSnippets = (payload) => {
  return putRequest(apiRoutes.kbSnippets, payload);
};

export const deleteSnippets = (payload) => {
  return deleteRequest(apiRoutes.kbSnippets, payload);
};
